import React, { useState } from 'react';
import Modal, { ModalInfo } from '../../organizations/Modal';
import Button, { ButtonType } from '../../general-components/Button';
import styles from './ConfirmActionButton.module.css';
interface ConfirmActionButtonProps {
    buttonText: string | React.ReactNode;
    modalInfo: ModalInfo;
    onConfirm: () => void;
    buttonType?: ButtonType;
    buttonClassName?: string;
    onCancel?: () => void;
    disabled?: boolean;
    children?: React.ReactNode;
    autoSubmit?: boolean;
}

const ConfirmActionButton: React.FC<ConfirmActionButtonProps> = ({
    buttonText,
    modalInfo,
    onConfirm,
    buttonType = ButtonType.action,
    buttonClassName = '',
    disabled = false,
    onCancel,
    children,
    autoSubmit = true,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleButtonClick = () => {
        setIsModalOpen(true);
    };

    const handleModalSubmit = () => {
        onConfirm();
        if (autoSubmit) {
            setIsSubmitted(true);
        }
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setIsSubmitted(false);
    };

    const handleModalCancel = () => {
        onCancel?.();
    };

    return (
        <>
            <Button
                small
                type={buttonType}
                onClick={handleButtonClick}
                className={`${buttonClassName} ${styles.button}`}
                disabled={disabled}
            >
                {buttonText}
            </Button>
            {isModalOpen && (
                <Modal
                    info={{
                        ...modalInfo,
                        isSubmitted: modalInfo.isSubmitted || isSubmitted,
                    }}
                    updateView={handleModalClose}
                    onCancel={handleModalCancel}
                    submitModal={handleModalSubmit}
                >
                    {children}
                </Modal>
            )}
        </>
    );
};

export default ConfirmActionButton;
